import { buildEntityState, EntityIdKey, EntityState } from './EntityState';

export type EntityIdState<T extends EntityIdKey> = EntityState<T> & {
  id: string | number | null;
};
export type buildIdState = <T extends EntityIdKey>(
  data: Partial<EntityIdState<T>>,
) => EntityIdState<T>;

export const buildEntityIdState: buildIdState = <T extends EntityIdKey>(
  data: Partial<EntityIdState<T>> = {},
) => {
  return {
    ...buildEntityState<T>(data),
    id: data.id ?? null,
  };
};
